import './ManageInitiatives.scss';
import { AimOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { InitiativeSelector } from './InitiativeSelector';
import { coreActions, FeatureFlag } from '@sonar-software/sonar-core';
import React, { useCallback } from 'react';
import { useAction, useAddToInitiative, useCurrentUser, useFeatureFlag, useOnMount, useRemoveFromInitiative, useSonarObjectReference } from '@hooks';
export const ManageInitiatives = ({ sonarObjectId }) => {
    const { request: add } = useAddToInitiative();
    const { request: remove } = useRemoveFromInitiative();
    const { initiativeIds } = useSonarObjectReference(sonarObjectId);
    const followersEnabled = useFeatureFlag(FeatureFlag.Followers);
    const { isReadOnly } = useCurrentUser();
    const getInitiativesForSonarObject = useAction(coreActions.requestGetCoreSonarObjectsInitiatives);
    useOnMount(() => {
        getInitiativesForSonarObject({ sonarObjectId });
    });
    const onSelect = useCallback((initiative) => {
        add({
            initiativeId: initiative.id,
            initiativeTitle: initiative.title,
            sonarObjectIds: [sonarObjectId]
        });
    }, [add, sonarObjectId]);
    const onDeselect = useCallback((initiative) => {
        remove({
            initiativeId: initiative.id,
            sonarObjectIds: [sonarObjectId]
        });
    }, [remove, sonarObjectId]);
    return (React.createElement(InitiativeSelector, { className: 'manage-initiatives', onDeselect: onDeselect, onSelect: onSelect, selectedIds: initiativeIds },
        React.createElement(Button, { icon: React.createElement(AimOutlined, null) }, followersEnabled && !isReadOnly ? '' : COPY_SPECIFIC.ADD_TO_INITIATIVE)));
};
